import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { isAuthenticated, signOut } from "../helpers/auth";

// This page is when a Applicant has a URL with a base64 endcoded data that will allow then to re-authinicate and complete thier re-declartion

const ReEntry: React.FC = () => {
  const { push } = useHistory();
  const { base64key } = useParams<{ base64key: string }>();
  const identityID = window.atob(base64key);

  // on mount
  React.useEffect(() => {
    const removeAuth = async () => {
      const userIsAuthenticated = await isAuthenticated();
      // remove logged in user if authenticated
      if (userIsAuthenticated) {
        //remove prev auth user for continue re-declare path
        await signOut();
      }
    };
    removeAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // build local storage key
  const localStorageKey = `CognitoIdentityId-${process.env.REACT_APP_APPLICANT_IDENTITY_POOL_ID}`;
  const localStorageValue = identityID;

  localStorage.setItem(localStorageKey, localStorageValue);

  push("/applications");

  return null;
};

export default ReEntry;
